import { IUploadImage } from '@/api/profile/types'
import { AvailableFormType, FormApplyRequest, FormSubmissionRequest, FormSubmissionResponse } from '@/types'
import { dictionaryWithKeys } from '@/utils'
import { Endpoints } from '../endpoints'
import { INetworkConfig, Instance } from '../instance'
import { IResponse, ISuccessResponse } from '../types'

const config: INetworkConfig = {
  baseURL: Endpoints.Base,
}

class FormSubmissionApi extends Instance {
  constructor(config: INetworkConfig) {
    super(config)
  }

  checkFormSubmission = (groupId?: number): Promise<IResponse<AvailableFormType>> =>
    this.get(Endpoints.FormSubmissionCheck)

  getFormSubmissionQuestions = (params: FormSubmissionRequest): Promise<IResponse<FormSubmissionResponse>> =>
    this.get(dictionaryWithKeys(Endpoints.FormSubmissionSingle, { id: params.id }), {
      params: { groupId: params.groupId },
    })

  uploadFormFile = (params: FormData): Promise<IResponse<IUploadImage[]>> =>
    this.post(Endpoints.UploadFormFile, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

  postFormSubmission = (params: FormApplyRequest): Promise<IResponse<ISuccessResponse>> =>
    this.post(Endpoints.FormsSubmissionApply, params)
}

export const formSubmissionApi = new FormSubmissionApi(config)
